import { NgModule } from '@angular/core';
import { SharedModule } from 'lib-trend-core';
import { ColorPickerDirective } from 'ngx-color-picker';
import { CustomFieldModule } from '../custom-field/custom-field.module';
import { LeadSourceModule } from '../lead-source/lead-source.module';
import { TabulationModule } from "../tabulation/tabulation.module";
import { TagEditComponent } from './tag-edit/tag-edit.component';
import { TagComponent } from './tag.component';

@NgModule({
  imports: [
    SharedModule,
    ColorPickerDirective,
    CustomFieldModule,
    TabulationModule,
    LeadSourceModule,
    ],
  declarations: [
    TagComponent,
    TagEditComponent,
  ],
  exports: [
    TagComponent,
  ]
})
export class TagModule { }
